import { render, staticRenderFns } from "./EditSenderProducts.vue?vue&type=template&id=2e0366f4&scoped=true"
import script from "./EditSenderProducts.vue?vue&type=script&lang=js"
export * from "./EditSenderProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0366f4",
  null
  
)

export default component.exports